export default "__VITE_ASSET__YYyfZ4jw__"